import { useState } from 'react';

import { CellContext, createColumnHelper } from 'core';
import { Table } from 'core/Packages';
import { centsToDollar, toTitleCase } from 'core/Utils';
import { DateTime } from 'luxon';
import { Stack, Text } from 'ui';
import { IconX } from 'ui/Icons';

import { Subscription } from '../../../../../api';
import { CampaignDonorNameHeader } from '../../Campaigns/Campaign/components';
import { CancelSubscriptionModal } from '../Modals/CancelSubscriptionModal';

const columnHelper = createColumnHelper<Subscription>();

const CartActions = (props: CellContext<Subscription, unknown>) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  if (props.row.original.status === 'canceled') return null;

  return (
    <>
      <Table.RowAction>
        <Table.RowAction.Option
          label="Cancel Future Payments"
          icon={IconX}
          onClick={() => setIsModalOpen(true)}
        />
      </Table.RowAction>
      <CancelSubscriptionModal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        subscription={props.row.original}
      />
    </>
  );
};
const subscriptionColumns = [
  columnHelper.accessor('donor_name', {
    header: () => <CampaignDonorNameHeader />,
    id: 'donor_name',
    cell: (props) => (
      <Stack gap={0}>
        <Text fz={'xs'}>{props.row.original.donor_name}</Text>
        <Text fz={'xxxs'}>{props.row.original.donor_email}</Text>
      </Stack>
    ),
    size: 250,
    enableSorting: false,
  }),

  columnHelper.accessor('price', {
    header: 'Recurring Amount',
    cell: (props) => centsToDollar(props.getValue()),
  }),

  columnHelper.accessor('created_at', {
    header: 'Start Date',
    cell: (props) => DateTime.fromISO(props.getValue()).toLocaleString(),
  }),

  columnHelper.accessor('number_of_payments', {
    header: 'Payments Made',
    cell: (props) => props.getValue(),
    enableSorting: false,
  }),

  columnHelper.accessor('status', {
    header: 'Status',
    enableSorting: false,
    cell: (props) => toTitleCase(props.getValue()),
    size: 100,
  }),

  // TODO: freeze rowactions to the right as table default
  columnHelper.display({
    id: 'actions',
    cell: (props) => <CartActions {...props} />,
    size: 40,
  }),
];
export { subscriptionColumns };
